import { render, staticRenderFns } from "./CardAnexoProtesto.vue?vue&type=template&id=6c3dc402&scoped=true"
import script from "./CardAnexoProtesto.vue?vue&type=script&lang=js"
export * from "./CardAnexoProtesto.vue?vue&type=script&lang=js"
import style0 from "./CardAnexoProtesto.vue?vue&type=style&index=0&id=6c3dc402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3dc402",
  null
  
)

export default component.exports